import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import useRetainedSearchBenefits from "@/hooks/useRetainedSearchBenefits";
import careImg from "@/assets/csr/care-work.png";
import useLocale from "@/hooks/useLocale";

export default function RetainedSearchBenefit({ title, dif, path }) {
  const locale = useLocale();
  const benefits = useRetainedSearchBenefits();

  return (
    <div className="container pt-10 lg:pt-24 pb-20 md:pb-[148px]">
      <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-purple max-w-[679px] 3xl:max-w-none">
        <CustomSourceFlowText
          title={title}
          path={`dynamic1.${path}.header2`}
          locale={locale}
        />
        {dif && <span className="text-pink">.</span>}
      </h2>
      <div className="flex justify-between pt-14 gap-10 flex-col md:flex-row">
        <div className="3xl:w-[80%]">
          <SourceFlowImage
            src={careImg ?? ""}
            size="607x400"
            alt="care work image"
            className="xmax-w-[607px] w-full max-h-[400px] md:max-h-[781px] h-full object-cover 3xl:max-w-none"
          />
        </div>
        <div className="text-purple text-lg sm:text-xl/8 max-w-[591px]">
          <ul className="list-disc pl-5">
            {benefits.map(({ id, label }, index) => (
              <li key={id}>
                <div
                  id="dynamicContent"
                  className={`text-purple text-sm sm:text-base md:text-lg lg:text-xl`}
                  dangerouslySetInnerHTML={{
                    __html: label.replace(/\n/g, "<br>"),
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
